import Vue from 'vue'
import Vuex from 'vuex'
import ls from 'local-storage'
import cookie from 'js-cookie'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    CUSUT: null, //登录用户签名
    menuList: null, //菜单
    userInfo: null, //登录用户信息
    priviList: null, //权限
    debug:null, //接口调试地址
    taskList: [],//上传任务
    accessToken: ''
  },
  mutations: {
    setCUSUT(state,data){
      state.CUSUT = data;
      ls.set('CUSUT',data);
    },
    setMenuList(state, data) {
      state.menuList = data;
      ls.set('menuList',data);
    },
    setUserInfo(state,data){
      state.userInfo = data;
      ls.set('userInfo',data);
    },
    setPriviList(state,data){
      state.priviList = data;
      ls.set('priviList',data);
    },
    logOut(state){
      state.menuList = null;
      state.CUSUT = null;
      state.userInfo = null;
      // state.priviList = null;
      ls.remove('CUSUT');
      ls.remove('menuList');
      ls.remove('userInfo');
      // ls.remove('priviList');
      cookie.remove('feishu_sso_key');
    },
    setDebug(state,data){
      state.debug = data;
      // ls.set('debug',data);
    },
    //上传任务
    SET_TASKLIST: (state, data) => {
      state.taskList = data;
    },
    setAccessToken(state,data){
      state.accessToken = data;
      ls.set('accessToken',data);
    }
  },
  actions: {
    //上传任务
    setTaskList({commit}, task) {
      commit('SET_TASKLIST', task);
    },
  },
  modules: {
  }
})
